
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';


function Pccepoxyflooring() {



  const cardData =
  {
    keyword: 'PCC Work & Epoxy Flooring Work ',
    heading: 'Anjali Enterprises: PCC Work & Epoxy Flooring Work ',
    headingDescription: 'Anjali Enterprises specializes in high-quality PCC (Plain Cement Concrete) work and epoxy flooring services in Pune. Our expertise ensures that your flooring needs, whether for residential, commercial, or industrial spaces, are met with precision, durability, and aesthetic appeal.',

    "topPlaces": [
    {
      "title": "PCC Work Services",
      "description": "We provide PCC work services to ensure solid and stable foundation surfaces. Our team works with the best materials and techniques to offer flawless concrete leveling and surface preparation for all types of construction projects."
    },
    {
      "title": "Concrete Leveling",
      "description": "Concrete leveling is an essential process to create smooth and even surfaces for flooring installations, ensuring durability and optimal performance. We provide concrete leveling services that are perfect for both new constructions and renovations."
    },
    {
      "title": "Epoxy Flooring Installation",
      "description": "We offer professional epoxy flooring installation services that are durable, functional, and visually appealing. Epoxy floors are ideal for high-traffic areas, providing a strong, long-lasting surface for both residential and commercial spaces."
    },
    {
      "title": "Industrial Epoxy Flooring",
      "description": "Our industrial epoxy flooring solutions are tailored to meet the heavy-duty needs of factories, warehouses, and other industrial spaces. These floors offer exceptional resistance to wear and tear, chemicals, and impact, ensuring a long-lasting solution for industrial environments."
    },
    {
      "title": "Custom Epoxy Flooring Solutions",
      "description": "We provide custom epoxy flooring solutions to meet your specific requirements. Whether you need a particular color, texture, or design, we work with you to create a personalized flooring system that suits your style and functionality."
    },
    {
      "title": "High-Quality Epoxy Work",
      "description": "Our high-quality epoxy work ensures superior finishes and performance. With a focus on longevity and strength, we provide the best epoxy coatings to enhance the aesthetic and durability of your floors."
    },
    {
      "title": "Commercial and Residential Epoxy Flooring",
      "description": "Whether it’s your commercial or residential property, we offer epoxy flooring solutions that are both practical and aesthetically pleasing. Our services cater to all types of spaces, providing you with floors that are not only functional but also visually stunning."
    },
    {
      "title": "Epoxy Coating for Floors",
      "description": "Our epoxy coating for floors provides a seamless and smooth surface that is resistant to stains, chemicals, and heavy use. This solution is ideal for homes, offices, industrial spaces, and commercial establishments."
    },
    {
      "title": "Durable Epoxy Flooring Contractors",
      "description": "As durable epoxy flooring contractors, we use the latest techniques and premium materials to ensure that your floors last for years. Our services are designed to withstand even the most demanding environments, providing a tough and reliable flooring solution."
    },
    {
      "title": "Decorative Epoxy Floors",
      "description": "We also offer decorative epoxy floors that add a unique and modern touch to any space. Our decorative epoxy flooring solutions are ideal for creating visually attractive floors with unique patterns, colors, and textures."
    },
    {
      "title": "Floor Screeding Services",
      "description": "Our floor screeding services are essential for creating a smooth base for further flooring work. We provide high-quality screeding that ensures an even, durable, and well-prepared surface for epoxy installation."
    },
    {
      "title": "Epoxy Flooring for Industrial Spaces",
      "description": "We specialize in epoxy flooring for industrial spaces, delivering resilient and functional solutions for factories, warehouses, and manufacturing plants. Our industrial-grade epoxy floors are designed to handle heavy machinery, chemicals, and intense traffic, making them perfect for industrial environments."
    },
    {
      "title": "Anjali Enterprises Contact Number",
      "description": "Contact Anjali Enterprises at +91 8793220265 for reliable and high-quality PCC (Plain Cement Concrete) work and epoxy flooring work. We specialize in providing durable and strong PCC solutions for foundations, pavements, and other structures, as well as high-performance epoxy flooring for industrial, commercial, and residential spaces. Get in touch for expert installation and professional service. Serving Pune with top-notch PCC and epoxy flooring work tailored to your specific needs."
    }
  ],
  "tableData": [
    ["- PCC work services", "- Concrete leveling"],
    ["- Epoxy flooring installation", "- Industrial epoxy flooring"],
    ["- Custom epoxy flooring solutions", "- High-quality epoxy work"],
    ["- Commercial and residential epoxy flooring", "- Epoxy coating for floors"],
    ["- Durable epoxy flooring contractors", "- Decorative epoxy floors"],
    ["- Floor screeding services", "- Epoxy flooring for industrial spaces"],
    ["- Contact Anjali Enterprises for expert service", ""]
  ],


    "whychoose": [
  {
    "WhyChooseheading": "Expert PCC Work Services",
    "WhyChoosedescription": "At Anjali Enterprises, we specialize in providing top-quality Plain Cement Concrete (PCC) work for a wide range of applications. Whether you're constructing a building, laying a foundation, or building roads and pavements, our skilled team ensures that your PCC work is executed with precision and care. We focus on delivering durable, reliable, and strong foundations for your construction projects, ensuring long-lasting results."
  },
  {
    "WhyChooseheading": "Premium Epoxy Flooring Solutions",
    "WhyChoosedescription": "Our epoxy flooring services are designed to enhance both the aesthetic appeal and functionality of your space. Ideal for residential, commercial, and industrial applications, we specialize in providing durable, low-maintenance, and visually striking flooring options. From warehouses to homes, our epoxy flooring provides the perfect combination of style, resilience, and easy upkeep."
  },
  {
    "WhyChooseheading": "Durability and Strength",
    "WhyChoosedescription": "Both our PCC and epoxy flooring work are highly durable and made to last. PCC provides a solid foundation that stands the test of time, while epoxy flooring offers a resilient surface that can withstand heavy foot traffic, chemicals, and regular wear and tear. Whether for construction or commercial use, we ensure that our work meets your long-term needs."
  },
  {
    "WhyChooseheading": "Versatile Applications",
    "WhyChoosedescription": "At Anjali Enterprises, we offer solutions for a wide variety of applications. Our PCC work is ideal for new building foundations, roads, and pavements, while our epoxy flooring is suitable for diverse spaces including warehouses, factories, garages, and homes. We cater to all types of residential, commercial, and industrial projects, providing tailored solutions to suit each unique need."
  },
  {
    "WhyChooseheading": "Skilled and Experienced Team",
    "WhyChoosedescription": "Our team of experts is highly skilled and experienced in both PCC work and epoxy flooring installation. We stay up-to-date with the latest industry trends, techniques, and best practices to ensure the highest standards of workmanship. Whether you need a solid foundation or a visually appealing floor, we have the experience to execute your project with excellence."
  },
  {
    "WhyChooseheading": "Advanced Techniques and Materials",
    "WhyChoosedescription": "We pride ourselves on using high-quality materials and advanced techniques in every project. Our epoxy flooring delivers a seamless finish that resists stains, chemicals, and scratches, ensuring long-term durability. For PCC work, we ensure that all foundations are solid and reliable, using the best materials to provide a stable base for your projects."
  },
  {
    "WhyChooseheading": "Customized Solutions",
    "WhyChoosedescription": "Every space and project is unique, which is why we offer customized solutions to meet your specific requirements. Whether you need a basic cement surface for your foundation or a glossy, decorative epoxy finish for your flooring, we offer a wide variety of colors, textures, and designs. We ensure that your project meets your aesthetic and functional needs."
  },
  {
    "WhyChooseheading": "Timely Completion and Efficient Service",
    "WhyChoosedescription": "We understand the importance of meeting deadlines in every project. At Anjali Enterprises, we prioritize timely project completion without compromising on quality. Our team ensures that both PCC work and epoxy flooring installations are completed efficiently and on time, keeping your projects on schedule and minimizing delays."
  },
  {
    "WhyChooseheading": "Cost-Effective Solutions",
    "WhyChoosedescription": "We provide cost-effective solutions that give you the best value for your investment. Whether you are building a strong foundation with PCC work or enhancing your space with durable epoxy flooring, we offer competitive pricing while maintaining high standards of quality. We provide clear estimates before beginning any project, ensuring that you know exactly what to expect."
  },
  {
    "WhyChooseheading": "Low Maintenance",
    "WhyChoosedescription": "Both our epoxy floors and PCC work are designed with low maintenance in mind. Epoxy floors are easy to clean and maintain, requiring minimal effort to keep them looking pristine. Similarly, PCC work offers a stable foundation with minimal upkeep, ensuring that you have long-lasting results that require little maintenance over time, helping to reduce future repair costs."
  }
]


  }

  const faqData = [
    {
      "question": "What is PCC work?",
      "answer": "PCC (Plain Cement Concrete) work involves mixing cement, sand, and aggregates in the right proportion to create a solid and durable base for construction. It is commonly used for foundations, roadways, and other structural applications."
    },
    {
      "question": "What are the benefits of epoxy flooring?",
      "answer": "Epoxy flooring provides a smooth, glossy, and durable surface. It is resistant to wear, chemicals, stains, and scratches. It is easy to clean, long-lasting, and ideal for areas with heavy foot traffic, such as warehouses, garages, and industrial floors."
    },
    {
      "question": "Can epoxy flooring be used in residential spaces?",
      "answer": "Yes, epoxy flooring is suitable for both commercial and residential spaces. It can be used in kitchens, bathrooms, living rooms, garages, and even basements to create a high-gloss, easy-to-clean surface."
    },
    {
      "question": "How long does it take to complete an epoxy flooring project?",
      "answer": "The duration of an epoxy flooring installation depends on the size of the area and the complexity of the design. On average, it takes 2-3 days to install and cure an epoxy floor, with the curing time being crucial for long-lasting results."
    },
    {
      "question": "How do I maintain epoxy flooring?",
      "answer": "Epoxy floors are low-maintenance. Regular sweeping and occasional mopping with mild soap and water will keep the surface looking new. Avoid using harsh chemicals or abrasive scrubbers that could damage the finish."
    },
    {
      "question": "What are the advantages of using PCC for construction?",
      "answer": "PCC provides a strong, durable base for construction projects. It is cost-effective, easy to mix, and offers high resistance to environmental factors. It ensures the stability of structures like roads, foundations, and pavements."
    },
    {
      "question": "Are there any design options for epoxy flooring?",
      "answer": "Yes, epoxy flooring comes in a variety of colors, textures, and finishes. You can choose from solid colors, metallic effects, or decorative flakes to create a unique look that suits your space."
    },
    {
      "question": "Is epoxy flooring slip-resistant?",
      "answer": "Yes, epoxy flooring can be made slip-resistant by adding aggregates to the coating, making it a safe option for high-traffic areas and wet environments."
    },
    {
      "question": "Is epoxy flooring suitable for industrial environments?",
      "answer": "Yes, epoxy flooring is highly durable and resistant to chemicals, heavy machinery, and other industrial elements. It is an ideal flooring solution for factories, warehouses, and other industrial settings."
    },
    {
      "question": "Why should I choose Anjali Enterprises for PCC and epoxy flooring work?",
      "answer": "Anjali Enterprises is known for its quality workmanship, experienced team, and commitment to customer satisfaction. We provide customized, affordable, and durable PCC work and epoxy flooring solutions, ensuring your projects are completed on time and to the highest standards."
    }
  ];
  
  const testimonials = [
    {
      "name": "Mr. Rajesh Kumar",
      "text": "We hired Anjali Enterprises for both PCC work and epoxy flooring in our new factory, and we couldn't be happier with the results. The team was professional, and the floors are durable and visually stunning. Highly recommended!"
    },
    {
      "name": "Ms. Neha Sharma",
      "text": "The epoxy flooring in my garage looks fantastic! Anjali Enterprises provided excellent service and delivered on time. The floor is easy to clean and looks great. I’m very satisfied with their work."
    }
  ];
  



  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>{testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: " Anjali Enterprises Contact Information:",
    contactNumbers: [
      "+91 8793220265",

    ],
    email: "info@anjalienterprisesindia.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "All Types of Aluminium Glass Office Partition",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "All Types of Toughened Glass Work",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Door Partition",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "ACP Cladding Panel Installation",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Aluminium Glass Window",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Soundproof Glass Window",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Aluminium Mosquito Net",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bird Net Installation",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Invisible Grill Installation",
    },
    {
      place: "/images/keyword/10.jpg",
      text: " MS Fabrication Door",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "MS Fabrication Shade",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "MS Fabrication Grill",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "MS Fabrication Slide Door ",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "MS Fabrication Industrial Shade",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "All Types of Industrial Fabrication Work",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "All Types of Furniture Work",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "All Types of Industrial Work",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "All Types of Home Renovation Work",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "All Types of Painting Work",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Foil Ceiling Work",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Electrical Work",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Puff Panel Room ",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "PCC Work & Epoxy Flooring Work ",
    },
  ];


  const images = [
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },

  ];



  return (
    <div>



<Helmet>
  <title>PCC Work & Epoxy Flooring Services in Pune</title>
  <meta name="description" content="Anjali Enterprises specializes in PCC work and epoxy flooring installation, offering services for both commercial and residential properties. Contact +91 8793220265 for high-quality epoxy coating, concrete leveling, and decorative flooring in Pune." />
  <meta name="keywords" content="PCC Work Services, Concrete Leveling, Epoxy Flooring Installation, Industrial Epoxy Flooring, Custom Epoxy Flooring Solutions, High-Quality Epoxy Work, Commercial and Residential Epoxy Flooring, Epoxy Coating for Floors, Durable Epoxy Flooring Contractors, Decorative Epoxy Floors, Floor Screeding Services, Epoxy Flooring for Industrial Spaces" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | PCC Work & Epoxy Flooring Services in Pune" />
  <meta property="og:description" content="Anjali Enterprises specializes in PCC work and epoxy flooring installation, offering services for both commercial and residential properties. Contact +91 8793220265 for high-quality epoxy coating, concrete leveling, and decorative flooring in Pune." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/pcc-epoxy-flooring.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/pcc-epoxy-flooring-services" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises specializes in PCC work and epoxy flooring installation, offering services for both commercial and residential properties. Contact +91 8793220265 for high-quality epoxy coating, concrete leveling, and decorative flooring in Pune.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/pcc-epoxy-flooring-services",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/pcc-epoxy-flooring.jpg",
        "priceRange": "₹3000 - ₹20000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/pcc-epoxy-flooring-services",
          "priceCurrency": "INR",
          "price": "3000",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "60"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Ravi K"
            },
            "datePublished": "2024-08-11",
            "reviewBody": "The epoxy flooring work done at our factory was exceptional. The floor is durable and looks great. Highly recommended for industrial flooring needs!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sushma T"
            },
            "datePublished": "2024-10-20",
            "reviewBody": "We had epoxy flooring installed in our office, and it looks fantastic! The team was professional, and the quality of work was excellent."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/pcc-epoxy-flooring-services"
        },
        "keywords": "PCC Work Services, Concrete Leveling, Epoxy Flooring Installation, Industrial Epoxy Flooring, Custom Epoxy Flooring Solutions, High-Quality Epoxy Work, Commercial and Residential Epoxy Flooring, Epoxy Coating for Floors, Durable Epoxy Flooring Contractors, Decorative Epoxy Floors, Floor Screeding Services, Epoxy Flooring for Industrial Spaces"
      }
    `}
  </script>
</Helmet>


      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className='text-white'>{cardData.keyword}</h1>
        </div>
      </div>



      <section>
        <div className="" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/23.jpg' className='img-fluid' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#24ABE2', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}

              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {/* {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))} */}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <h3 className='Colo'>Why Choose Anjali Enterprises for {cardData.keyword}  </h3>

              <div id="why-choose-section"
                className='px-2'>


                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>

              <div>
                <h3 className='Colo'>FAQs{cardData.keyword} for Anjali Enterprises</h3>
                <Accordion data={faqData} />
              </div>
              <div className=''>


                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>

              <div className='py-5'>

                <div className="contact-box borderrr py-md-3">
                  <h2>{contactData.heading}</h2>
                  <p>For inquiries, quotes, or assistance with your aluminium glass office partition needs, please contact us:</p>
                  <div className="contact-details">
                    <p><strong className=''>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5 darkcolor">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className=''>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link darkcolor">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >

              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>

                );
              })}










              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #24ABE2',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                  color: 'white'
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#24ABE2' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8793220265 " className="d-block  text-white">+91 8793220265 </a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@anjalienterprisesindia.com" className=" text-white d-block">
                          info@anjalienterprisesindia.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i>

                            Anjali Enterprises:<br />
                            Shop No 7 Vishal Deep Residency M  <br />
                            Perk Nagar Highway, Chandan Nagar<br />
                            Vadgaon Sheri,  (Near NA Bus Stop) Pune <br />
                            Maharashtra 411014
                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Gallery images={images} ></Gallery>

              </div>

            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Pccepoxyflooring;